import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import "../General/NotificationStyle.css";
import RecipientModal from "../General/RecipientModal";
import { useDispatch } from "react-redux";
import actions from "../../../store/notificatiommodule/action";
import Services from "../General/NotificationService";
import { toast } from "react-toastify";
import $ from "jquery";

// 🔹 Level 3: Recipients Table
const RecipientTable = ({ recipients }) => {
  const columns = [
    {
      headerClasses: "text-nowrap text-secondary",
      classes: "px-3 py-2 c-pointer",
      dataField: "recipient_Name",
      headerStyle: {
        width: "80%",
      },
      text: "Name",
    },
    {
      headerClasses: "text-nowrap text-secondary",
      classes: "px-3 py-2 c-pointer",
      dataField: "recipient_Type",
      text: "Type",
    },
  ];

  return (
    <div className="pt-3">
      <BootstrapTable
        keyField="id"
        data={recipients}
        classes="notification-recipient-Table"
        columns={columns}
        bootstrap4
        wrapperClasses="notification-trigger-table-wrapper"
      />
    </div>
  );
};

export default RecipientTable;
